import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withPermission } from "../../../../context";
import { Link } from 'react-router';

class InfoPod extends Component {
    static propTypes = {
        permission: PropTypes.object
    }

    static defaultProps = {
        permission: { canEdit: true }
    }

    render() {
        return (

            <div className="pod">

                <div className="pod__total-number">
                    {this.props.subscription >= 0 ?
                        this.props.subscription + ' / ' + this.props.data :
                        <span>{this.props.data}</span>}
                </div>

                <div className="pod__total-info">
                    {this.props.text}
                </div>
                {this.props.permission.canEdit &&
                <div className="pod__total-url">
                    <Link to={this.props.link}>
                        {this.props.linkText}
                    </Link>

                </div>
                }

            </div>
        );
    }
}

export default withPermission(InfoPod);


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/Dashboard.infoPod.jsx